import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Pagination } from '../../../components/Pagination';
import { fetchVehicleInvoices } from '../../Invoices/actions';
import { selectWorks } from '../../Api/selectors';
import { selectInvoiceFilter, selectPaginator } from '../../Invoices/selectors';
import { InvoicesCompanyTable } from '../../Invoices/components/InvoicesCompanyTable';

import { selectWebloginVehicleInvoices } from '../../Weblogin/selectors';
import { fetchWebloginVehicleInvoices } from '../../Weblogin/actions';
import { WEBLOGIN_FETCH_VEHICLE_INVOICES } from '../constants';
import cn from 'classnames';
import styles from './WebloginVehicleInvoicesCard.module.css';

const Container = styled.div`
  width: 100%;
  font-size: 14px;
  .info-card {
    min-width: 260px;
    width: 100%;
  }
  .cell:first-child {
    text-transform: capitalize;
  }
  .wide {
    width: 100%;
    
  }
`;

const STATE = { searchString: '' };
/* eslint-disable react/prefer-stateless-function */
class WebloginVehicleInvoicesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchWebloginVehicleInvoices();
  }

  componentDidUpdate(prevProps, prevState) {}

  selectPage = newPage => {
    if (newPage === this.state.currentPage) return;
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter(newOffset));
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.searchString);
    }
  };

  doSearch() {
    this.props.setSearchString(this.state.searchString);
  }

  render() {
    const isInvoicePage = this.props.isInvoicePage;

    return (
      <Container itemsLength={this.props.invoices?.length} isInvoicePage={isInvoicePage} className={styles.container}>
        <Card className={cn("vehicle-info-card info-card data wide", styles.card)} style={{ width: '100%' }}>
          <HBox vCenter className='mb-2'>
            <h2 className="card-title mb-2 text-muted">{this.lbl('company.info.data.invoices')}</h2>
          </HBox>
          <div>
            <InvoicesCompanyTable weblogin vehicleId={this.props.vehicle?.id} />
          </div>
          {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
            <Pagination paginator={this.props.paginator} selectPage={this.selectPage} />
          )}
        </Card>
      </Container>
    );
  }
}

WebloginVehicleInvoicesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoices: selectWebloginVehicleInvoices(),
    paginator: selectPaginator(),
    work: selectWorks([`${WEBLOGIN_FETCH_VEHICLE_INVOICES}-${ownProps.vehicle?.id}`]),
    filter: selectInvoiceFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    changeFilter: offset => {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id, '', offset));
    },
    fetchWebloginVehicleInvoices() {
      dispatch(fetchWebloginVehicleInvoices(ownProps.vehicle?.id));
    },
    setSearchString(text) {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id, text));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehicleInvoicesCard = compose(withConnect, withRouter)(WebloginVehicleInvoicesCardComp);
